module.exports = {"title":"Get in touch","image":"/media/contactus_cover.jpg","trustpilot":true}